import _ from 'lodash';
import { required, numeric } from 'vuelidate/lib/validators';
import ToolkitMixin from '@/app/mixins/toolkit/item';
import AssetClassifications from '@/app/constants/store/toolkit/inv-strat/asset-classifications.json';
import InvStratAsset from '@/app/modules/toolkit/inv-strat/components/inv-strat-asset/inv-strat-asset.vue';
import InvStratOtherAssetsDialog from '@/app/modules/toolkit/inv-strat/components/inv-strat-other-assets-dialog/inv-strat-other-assets-dialog.vue';

function initNewAsset() {
  return {
    name: '',
    min: 0,
    max: 100,
  };
}

export default {
  name: 'inv-strat-assets',
  components: {
    InvStratAsset,
    InvStratOtherAssetsDialog,
  },
  mixins: [ToolkitMixin],
  data: () => ({
    isAdd: false,
    newAsset: initNewAsset(),
    classifications: _.cloneDeep(AssetClassifications),
    showOtherAssetDialog: false,
  }),
  computed: {
    assets() {
      return this.getItem.assets;
    },
    otherAssets() {
      const otherAsssetIdx = this.assets.findIndex(asset => asset.name === 'Other');
      return otherAsssetIdx > -1 ? this.assets[otherAsssetIdx].assets : [];
    },
    newRangeStyle() {
      return {
        left: `${this.newAsset.min}%`,
        width: `${this.newAsset.max - this.newAsset.min}%`,
      };
    },
    unusedClassifications() {
      if (this.assets.length > 0) {
        // eslint-disable-next-line max-len
        const sortedClassifications = this.classifications.sort((newValue, oldValue) => newValue.order - oldValue.order);
        const flatAssets = this.assets.flatMap(asset => asset.name);
        // eslint-disable-next-line max-len
        return sortedClassifications.filter(classification => !flatAssets.includes(classification.name.heffron));
      }
      return this.classifications;
    },
  },
  methods: {
    handleMinChange(pos, value) {
      const assets = _.cloneDeep(this.assets);
      assets[pos].min = value;

      this.setItem({
        replace: true,
        assets,
      });
    },
    handleMaxChange(pos, value) {
      const assets = _.cloneDeep(this.assets);
      assets[pos].max = value;
      this.setItem({ replace: true, assets });
    },

    handleChange() {
      if (this.newAsset.name === 'Other') {
        this.showOtherAssetDialog = true;
        this.$set(this.newAsset, 'assets', []);
      }
      this.setItem({
        replace: true,
        assets: [...this.assets, this.newAsset],
      });
      this.newAsset = initNewAsset();
      this.isAdd = false;
    },
    handleDelete(pos) {
      this.setItem({
        replace: true,
        assets: this.assets.filter((asset, idx) => idx !== pos),
      });
    },
    handleAddOtherAsset(other) {
      const otherAsset = this.assets.filter(asset => asset.name === 'Other')[0];

      this.setItem({
        replace: true,
        assets: [
          ...this.assets.filter(asset => asset.name !== 'Other'),
          {
            ...otherAsset,
            assets: [...otherAsset.assets, other],
          },
        ],
      });
    },
    handleDeleteOtherAsset(pos) {
      const otherAsset = this.assets.filter(asset => asset.name === 'Other')[0];

      this.setItem({
        replace: true,
        assets: [
          ...this.assets.filter(asset => asset.name !== 'Other'),
          {
            ...otherAsset,
            assets: otherAsset.assets.filter((asset, idx) => idx !== pos),
          },
        ],
      });
    },
  },
  validations: {
    assets: {
      required,
      minGreaterThan100(assets) {
        const minTotalValue = assets.reduce((accum, value) => accum + value.min, 0);
        return minTotalValue <= 100;
      },
      maxLessThan100(assets) {
        const maxTotalValue = assets.reduce((accum, value) => accum + value.max, 0);
        return maxTotalValue >= 100;
      },
      $each: {
        required,
        min: {
          required,
          numeric,
        },
        max: {
          required,
          numeric,
          greaterThanMin(value, vm) {
            return value >= vm.min;
          },
        },
        isMinMax(values) {
          return !(values.max === 100 && values.min === 0);
        },
      },
    },
  },
};
